import { useTranslation } from "react-i18next";
import z from "zod";

const translationPath = "chatBot.page.service.blacklist.errors.";

const individualSchema = z.object(
  {
    identifier: z.string(),
    individualName: z.string(),
    document: z.string(),
    establishmentId: z.string(),
  },
  {
    invalid_type_error: translationPath + "individual" || "Required field",
  }
);

const ddiSchema = z.object(
  {
    id: z.string(),
    code: z.string(),
    name: z.string(),
    ddiCode: z.string().nullable(),
    phoneMask: z.string().nullable(),
  },
  {
    invalid_type_error: translationPath + "ddi" || "Required field",
  }
);

export const blacklistSchema = z.object({
  id: z.string().optional(),
  phoneNumberValue: z
    .string()
    .min(1, translationPath + "phone_number_value" || "Required field"),
  ddi: ddiSchema,
  enable: z.boolean(),
  individual: individualSchema,
});

export type TBlacklistForm = z.infer<typeof blacklistSchema>;
